import { Mail, MessageSquareText, Layers, Lock } from "lucide-react";

export const MODES = [
  { id: "email_first", icon: Mail, label: "Email first", tag: "Recommended · free",
    hint: "Everyone with an email gets the email. Only residents without one get the text." },
  { id: "sms_first", icon: MessageSquareText, label: "Text first", tag: "Time-sensitive · ~1¢ per segment each",
    hint: "Everyone with a mobile gets the text. Anyone without one gets the email." },
  { id: "both", icon: Layers, label: "Text + email", tag: "Everyone, both ways",
    hint: "Both channels to every resident. Safety alerts always use this." },
];

export const modeLabel = (id) => MODES.find((m) => m.id === id)?.label || "Text + email";

// Email is free, a text costs money — so the default is email and the text fills the gaps.
export const DeliveryModePicker = ({ mode, onChange, locked }) => (
  <div data-testid="delivery-mode-picker">
    <div className="flex items-center justify-between mb-2">
      <label className="block text-xs font-bold text-ink/50">How it goes out</label>
      {locked && <span data-testid="delivery-mode-locked" className="inline-flex items-center gap-1 text-[11px] font-semibold text-redline-700"><Lock className="h-3 w-3" /> Safety alerts reach everyone both ways</span>}
    </div>
    <div className="grid gap-2 sm:grid-cols-3">
      {MODES.map((m) => {
        const on = mode === m.id;
        return (
          <button key={m.id} type="button" data-testid={`delivery-mode-${m.id}`} onClick={() => !locked && onChange(m.id)} disabled={locked && !on}
            className={`text-left rounded-2xl border px-3.5 py-3 transition-colors disabled:opacity-40 ${on ? "border-ink bg-sand-50" : "border-sand-200 bg-white hover:border-ink/40"}`}>
            <div className="flex items-center gap-2 font-heading font-bold text-sm text-ink"><m.icon className="h-4 w-4 text-ink/70" strokeWidth={1.75} /> {m.label}</div>
            <div className={`text-[10px] font-bold uppercase tracking-wider mt-0.5 ${m.id === "email_first" ? "text-emerald-700" : "text-ink/45"}`}>{m.tag}</div>
            <p className="text-[11px] text-ink/55 mt-1 leading-snug">{m.hint}</p>
          </button>
        );
      })}
    </div>
  </div>
);
